export default __webpack_public_path__ + "static/media/WINBET-logo.92e8ea6e.png";